module.exports = __webpack_public_path__ + "static/icon-operateur-2aa9e5664c59f2df959fbd1cd6f41c3f.png";